import { useFetch } from '@/composables/useFetch';
import { endpointsList } from '@/helpers';
import axios from 'axios';
import { IUploadUpdateDependenciesDto } from 'types';
import { useI18n } from 'vue-i18n';

export function useGetUploadUpdateDependencies(uploadId: string) {
  const { t } = useI18n();

  const { isLoading: isLoadingDependencies, data: uploadUpdateDependencies } =
    useFetch<IUploadUpdateDependenciesDto>(
      async () => {
        const response = await axios.get<IUploadUpdateDependenciesDto>(
          endpointsList.uploadHandler.uploadUpdateHandler.getUploadUpdateDependencies(
            uploadId,
          ),
        );
        return response.data;
      },
      () => {
        t('uploadUpdateView.errors.errorGettingUploadData');
      },
    );

  return { isLoadingDependencies, uploadUpdateDependencies };
}
